var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"questionare-text bold big",class:{'low-opacity': _vm.fullfilling}},[_vm._v(_vm._s(_vm.income ? _vm.income.toLocaleString() : 0)+" EUR / m")]),(_vm.fullfilling)?_c('b-spinner',{staticClass:"align-self-center",attrs:{"variant":"primary"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }